const state = {
    notifications:[],
};

const getters = {
    getNotifications: state => state.notifications,
};

const actions = {
    setNotifications: (store, payload) => store.commit("NOTIFICATIONS_SET",payload),
};

const mutations = {
    NOTIFICATIONS_SET: (state, payload) => state.notifications = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};